const Pie = {
    initOptions() {
        return {
            renderer: 'canvas'
        }
    },
    /**
     * {
     * title: 'xxxx',
     * titleTop: '20%',
     * textTop: '20%',
     * xData: [],
     * yData: [],
     * }
     */
    getOptions(opt) {
        return {
            tooltip: {
                ...{
                    trigger: 'item',
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                ...opt.tooltip
            },
            color: opt.color || ['#7ED321', '#59A7FF', '#FF4C18', '#FFB000', '#A947FF'],
            legend: {
                orient: 'vertical',
                x: 'left',
                top: '30px',
                ...opt.legend
            },
            graphic:{
                type: "text",
                left: "center",
                top: opt.textTop || "42%",
                style:{
                    text: '',
                    textAlign:"center",
                    fill: "#6E7290",
                    fontSize: 10,
                    fontWeight: 400,
                    ...(opt.graphicStyle || {})
                },
                ...(opt.graphic || {})
            },
            title:{
                text: opt.title,
                left:"center",
                top: opt.titleTop || "30%",
                textStyle:{
                    color:"#333",
                    fontSize: opt.titleSize || 14,
                    align:"center"
                },
                subtext: opt.subtext,
                subtextStyle: {
                    ...(opt.subtextStyle || {})
                },
                ...(opt.titleExtra || {})
            },
            grid: {
                // show: true,
                // top:0,
                // left:0,
                // width: 400,
                height: 360,
                ...(opt.grid || {})
            },
            series: opt.series || [
                {
                    name: opt.title,
                    type: 'pie',
                    center: ['50%', '50%'],
                    radius: opt.radius || [80, 130],
                    avoidLabelOverlap: false,
                    label: {
                        normal: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            show: false,
                            textStyle: {
                                fontSize: '30',
                                fontWeight: 'bold'
                            }
                        }
                    },
                    data: opt.yData,
                    // itemStyle:{
                    //     normal: {
                    //         borderWidth: opt.yData[0].value >= 100 || opt.yData[0].value===0 ? 0 : 2,
                    //         borderColor: '#fff',
                    //     }
                    // },
                    silent: true
                }
            ]
        }
    },
}

export default Pie
